import React from "react";
import { useTranslation } from "react-i18next";
import Omega3Img from "../../assets/omega3/1.webp";
import CreatineImage from "../../assets/creatine.webp";
import Energy from "../../assets/smart-formulas/energy.webp";
import Stress from "../../assets/smart-formulas/stress.webp";
import Sleep from "../../assets/smart-formulas/sleep.webp";
import Beauty from "../../assets/smart-formulas/beauty.webp";
import ImmuneSystem from "../../assets/smart-formulas/immune-system.webp";
import Performance from "../../assets/smart-formulas/sport.webp";
import CustomLink from "../CustomLink";
import "./Products.css";
import {
  TagEnergy,
  TagImmunity,
  TagBeauty,
  TagStress,
  TagPerformance,
  TagSleep,
  ProdSectionQuiz,
  ProdSectionQuizSub,
  ProdSectionFormulas,
  ProdSectionFormulasSub,
  ProdSectionAddons,
  ProdSectionAddonsSub,
  ProdFormulasLabel,
  ProdFormulasTitle,
  ProdFormulasSub,
  ProdQuizNudge,
  ProdQuizNudgeCTA,
  ProdAddonsLabel,
  ProdAddonsTitle,
  ProdAddonsSub,
  EnergyDesc,
  ImmuneSystemDesc,
  BeautyDesc,
  StressDesc,
  PerformanceDesc,
  SleepDesc,
  Omega3New,
  Omega3Title,
  Omega3Tagline,
  Omega3Spec1,
  Omega3Spec2,
  Omega3Spec3,
  Omega3Spec4,
  Omega3CTA,
  Omega3Stat1Val,
  Omega3Stat1Lbl,
  Omega3Stat1Note,
  Omega3Stat2Val,
  Omega3Stat2Lbl,
  Omega3Stat2Note,
  Omega3Stat3Val,
  Omega3Stat3Lbl,
  Omega3Stat3Note,
  Omega3Cert,
  ProdComingSoon1,
  ProdComingSoon1Sub,
  Days30,
} from "../../Constants";

const FORMULAS = [
  {
    key: "energy",
    image: Energy,
    href: "/products/energy",
    tagKey: TagEnergy,
    tagClass: "formula-tag--energy",
    nameKey: "EnergyFA",
    descKey: EnergyDesc,
    price: 49,
  },
  {
    key: "immune-system",
    image: ImmuneSystem,
    href: "/products/immune-system",
    tagKey: TagImmunity,
    tagClass: "formula-tag--immunity",
    nameKey: "ImmuneSystemFA",
    descKey: ImmuneSystemDesc,
    price: 39,
  },
  {
    key: "beauty",
    image: Beauty,
    href: "/products/beauty",
    tagKey: TagBeauty,
    tagClass: "formula-tag--beauty",
    nameKey: "BeautyFA",
    descKey: BeautyDesc,
    price: 32,
  },
  {
    key: "stress",
    image: Stress,
    href: "/products/stress",
    tagKey: TagStress,
    tagClass: "formula-tag--stress",
    nameKey: "StressFA",
    descKey: StressDesc,
    price: 59,
  },
  {
    key: "performance",
    image: Performance,
    href: "/products/performance",
    tagKey: TagPerformance,
    tagClass: "formula-tag--performance",
    nameKey: "SportsFA",
    descKey: PerformanceDesc,
    price: 69,
  },
  {
    key: "sleep",
    image: Sleep,
    href: "/products/sleep",
    tagKey: TagSleep,
    tagClass: "formula-tag--sleep",
    nameKey: "SleepFA",
    descKey: SleepDesc,
    price: 49,
  },
];

const Products = () => {
  const { t } = useTranslation();

  return (
    <div className="products-page">

      {/* ── Section nav ── */}
      <nav className="products-section-nav">
        <div className="products-section-nav-inner">
          <CustomLink to="/quiz" className="snav-pill--quiz">
            <img src="/bannermenu.webp" alt="" className="snav-quiz-bg" />
            <div className="snav-quiz-overlay" />
            <div className="snav-quiz-content">
              <span className="snav-label">{t(ProdSectionQuiz)}</span>
              <span className="snav-sub">{t(ProdSectionQuizSub)}</span>
              <span className="snav-quiz-cta">→</span>
            </div>
          </CustomLink>

          <a className="snav-pill" href="#formulas">
            <span className="snav-icon">⬡</span>
            <div className="snav-text">
              <span className="snav-label">{t(ProdSectionFormulas)}</span>
              <span className="snav-sub">{t(ProdSectionFormulasSub)}</span>
            </div>
            <span className="snav-arrow">↓</span>
          </a>

          <a className="snav-pill" href="#addons">
            <span className="snav-icon">○</span>
            <div className="snav-text">
              <span className="snav-label">{t(ProdSectionAddons)}</span>
              <span className="snav-sub">{t(ProdSectionAddonsSub)}</span>
            </div>
            <span className="snav-arrow">↓</span>
          </a>
        </div>
      </nav>

      {/* ── Smart Formulas ── */}
      <section className="products-section" id="formulas">
        <p className="section-eyebrow">{t(ProdFormulasLabel)}</p>
        <h2 className="section-title">{t(ProdFormulasTitle)}</h2>
        <p className="section-sub">{t(ProdFormulasSub)}</p>

        <div className="formula-grid">
          {FORMULAS.map((f) => (
            <CustomLink to={f.href} key={f.key} className="formula-card">
              <div className="formula-card-img">
                <img src={f.image} alt={t(f.nameKey)} />
              </div>
              <div className="formula-card-body">
                <span className={`formula-tag ${f.tagClass}`}>{t(f.tagKey)}</span>
                <p className="formula-card-name">{t(f.nameKey)}</p>
                <p className="formula-card-desc">{t(f.descKey)}</p>
                <div className="formula-card-price">
                  <span className="formula-card-price-amount">{f.price}€</span>
                  <span className="formula-card-price-period">{t("Days30")}</span>
                </div>
              </div>
            </CustomLink>
          ))}
        </div>

        <p className="quiz-nudge">
          {t(ProdQuizNudge)}{" "}
          <CustomLink to="/quiz">{t(ProdQuizNudgeCTA)}</CustomLink>
        </p>
      </section>

      <hr className="products-divider" />

      {/* ── Add-ons ── */}
      <section className="addons-section" id="addons">
        <p className="section-eyebrow">{t(ProdAddonsLabel)}</p>
        <h2 className="section-title">{t(ProdAddonsTitle)}</h2>
        <p className="section-sub">{t(ProdAddonsSub)}</p>

        {/* Omega-3 card */}
        <div className="omega-card">
          <div className="omega-img-panel">
            <img src={Omega3Img} alt="Omega-3 Fish Oil" />
          </div>

          <div className="omega-content">
            <span className="omega-new-badge">{t(Omega3New)}</span>
            <h3 className="omega-title">{t(Omega3Title)}</h3>
            <p className="omega-tagline">{t(Omega3Tagline)}</p>
            <div className="omega-specs">
              {[Omega3Spec1, Omega3Spec2, Omega3Spec3].map((key) => (
                <div className="omega-spec" key={key}>
                  <span className="omega-spec-dot" />
                  <span>{t(key)}</span>
                </div>
              ))}
            </div>
            <CustomLink to="/products/omega-3" className="omega-cta">
              {t(Omega3CTA)}
            </CustomLink>
          </div>
        </div>

        <div className="t-mt-4 t-flex t-flex-wrap t-items-center t-gap-4 t-rounded-2xl t-border t-border-solid t-border-g200 t-bg-white t-p-5">
          <img src={CreatineImage} alt="" className="t-h-24 t-w-24 t-flex-none t-rounded-xl t-object-contain" />
          <div>
            <h3 className="t-m-0 t-text-xl t-font-bold t-text-navy">{t('ProdCreatineTitle')}</h3>
            <span className="t-mt-2 t-inline-block t-rounded-full t-bg-butter t-px-3 t-py-1 t-text-xs t-font-bold t-text-navy">
              {t('ProdCreatineComingSoon')}
            </span>
          </div>
        </div>

        <div className="addons-coming-soon">
          <div className="coming-soon-card">
            <span className="coming-soon-icon">◎</span>
            <div className="coming-soon-text">
              <strong>{t(ProdComingSoon1)}</strong>
              {t(ProdComingSoon1Sub)}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Products;
